const AFRAME = window.AFRAME

const livingImage = AFRAME.registerComponent('living-image', {
  schema: {
    title: {
      type: 'string',
      default: 'Unbenannt'
    },
    fadeTime: {
      type: 'number',
      default: 1500
    },
    loadingOverlay: {
      type: 'selector'
    },
    muted: {
      type: 'boolean',
      default: true
    },
    found: { // true when user activated living image for the first time
      type: 'boolean',
      default: false
    },
    active: { // true when marker found, doesn't mean material is visible
      type: 'boolean',
      default: false
    },
    fading: { // true when fading in or our
      type: 'boolean',
      default: false
    },
    loading: {
      type: 'boolean',
      default: true
    },
    playing: {
      type: 'boolean',
      default: false
    },
    userPaused: {
      type: 'boolean',
      default: false
    },
    ended: {
      type: 'boolean',
      default: false
    },
    duration: {
      type: 'number',
      default: 0
    },
    currentTime: {
      type: 'number',
      default: 0
    }
  },
  init() {
    // references
    this.material = this.el.components.material.material
    this.video = this.el.sceneEl.querySelector(this.el.getAttribute('src'))
    this.marker = this.el.parentEl
    this.scene = document.querySelector('#scene')
    this.siblings = this.scene.querySelectorAll('[living-image]')

    this.material.visible = false

    // video events
    this.video.onloadstart = (e) => {
      console.log('onstartload', e)
      this.el.emit('consolemessage', this.data.title + ': onstartload')
    }
    this.video.oncanplaythrough = (e) => {
      console.log('oncanplaythrough', e)
      this.el.emit('consolemessage', this.data.title + ': oncanplaythrough')
      if (this.data.loading) {
        this.showLoadingOverlay(false)
      }
    }
    this.video.onloadeddata = (e) => {
      // first frame finished loading
      console.log('onloadeddata', e)
      this.el.emit('consolemessage', this.data.title + ': onloadeddata')
    }
    this.video.onloadedmetadata = (e) => {
      console.log('onloadedmetadata', e)
      this.el.emit('consolemessage', this.data.title + ': onloadedmetadata')
      this.data.duration = this.video.duration
    }
    this.video.ontimeupdate = () => {
      this.data.currentTime = this.video.currentTime
      // start fading out shortly before end
      if (this.data.duration <= this.data.fadeTime / 1000) return
      if (this.data.currentTime >=
        this.data.duration - this.data.fadeTime / 1000 &&
        !this.data.fading &&
        !this.data.ended) {
        console.log('FADEOUT')
        this.el.emit('fade-out')
        this.data.fading = true
      }
    }
    this.video.onwaiting = (e) => {
      console.log('Video wird nachgeladen', e)
      this.el.emit('consolemessage', this.data.title + ': onwaiting')
      this.showLoadingOverlay(true)
    }
    this.video.onstalled = (e) => {
      console.log('Video wird versucht zu laden, aber keine Daten vorhanden', e)
      this.el.emit('consolemessage', this.data.title + ': onstalled')
      this.showLoadingOverlay(true)
    }
    this.video.onpause = () => {
      this.data.playing = false
    }
    this.video.onplaying = () => {
      this.data.playing = true
      if (this.data.loading) {
        this.showLoadingOverlay(false)
      }
    }
    this.video.onended = () => {
      this.data.fading = false
      this.material.visible = false
      this.data.userPaused = false
      this.data.ended = true
      this.data.active = false
    }
    this.video.onsuspend = (e) => {
      // loading has been suspended by browser
    }
    this.video.onerror = () => {
      console.error('Ein Fehler ist aufgetreten!')
      this.el.emit('consolemessage', this.data.title + ': onerror: ' + this.video.error.code)
    }

    // executed when marker found
    this.marker.addEventListener('markerFound', (e) => {
      console.log('Marker gefunden', this.data.title)
      this.el.emit('consolemessage', this.data.title + ': Marker gefunden')
      if (this.video.readyState < 3) return
      // only activated when no other video is playing
      if (Array.from(this.siblings).find(el =>
        el.components['living-image'].data.active === true)) return

      this.data.active = true
      this.material.visible = true

      if (this.data.userPaused) return
      this.playVideo()

      // start fade in animation when played for first time or after having finished
      if (!this.data.found || this.data.ended) {
        this.data.ended = false
        this.data.found = true
        this.el.emit('fade-in')
        this.data.fading = true
        setTimeout(() => {
          this.data.fading = false
        }, this.data.fadeTime)
      }
    })

    // executed when marker lost
    this.marker.addEventListener('markerLost', (e) => {
      console.log('Marker verloren', this.data.title)
      this.el.emit('consolemessage', this.data.title + ': Marker verloren')
      this.data.active = false
      this.material.visible = false
      this.pauseVideo()
    })

    this.el.sceneEl.addEventListener('loaded', () => {
      console.log('Scene geladen')
      const ua = window.navigator.userAgent
      const isIOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      if (isIOS) {
        this.video.load()
        console.log('isIOS, load() started manually')
        this.el.emit('consolemessage', 'is iOS, load() manually')
      }
    })
  },
  update: function (oldData) {
    // mute button interaction
    if (this.data.muted !== oldData.muted) {
      this.toggleMute(this.data.muted)
    }
    
    // executed only when visible
    if (this.data.active) {
      // play/pause button interaction
      if (this.data.userPaused !== oldData.userPaused) {
        this.data.userPaused
          ? this.pauseVideo()
          : this.playVideo()
      }
    }
  },
  showLoadingOverlay(loading) {
    this.data.loading = loading
    if (!this.data.loadingOverlay) return
    this.data.loadingOverlay.object3D.visible = loading
    this.data.loadingOverlay.components.animation__rotation.enabled = loading
  },
  toggleMute(muted) {
    if (!this.video) return
    this.video.muted = muted
  },
  playVideo() {
    const playPromise = this.video.play()
    if (playPromise !== undefined) {
      playPromise.then(() => {
        console.log('Playing: ', this.el.id)
        this.el.emit('consolemessage', this.data.title + ': Playing')
      }).catch((error) => {
        alert('Das Video konnte nicht abgespielt werden. Fehlermeldung: ', error.message)
        console.error('Playing failed:', error.message)
        this.el.emit('consolemessage', this.data.title + ': Playing failed: ' + error.message)
      })
    }
  },
  pauseVideo() {
    this.video.pause()
  }
})

export default livingImage
